import { ref, reactive } from 'vue'

// Global loading state
const globalLoading = reactive({
  show: false,
  title: 'กำลังโหลด...',
  message: '',
  progress: 0,
  showProgress: false
})

export function useLoading() {
  const localLoading = ref(false)

  // Show global loading
  const showLoading = (options = {}) => {
    globalLoading.show = true
    globalLoading.title = options.title || 'กำลังโหลด...'
    globalLoading.message = options.message || ''
    globalLoading.progress = options.progress || 0
    globalLoading.showProgress = options.showProgress || false
  }

  // Hide global loading
  const hideLoading = () => {
    globalLoading.show = false
    globalLoading.title = 'กำลังโหลด...'
    globalLoading.message = ''
    globalLoading.progress = 0
    globalLoading.showProgress = false
  }

  // Update loading progress
  const updateProgress = (progress, message = '') => {
    globalLoading.progress = progress
    if (message) {
      globalLoading.message = message
    }
  }

  // Async wrapper that shows loading
  const withLoading = async (asyncFunction, options = {}) => {
    try {
      showLoading(options)
      const result = await asyncFunction()
      return result
    } finally {
      hideLoading()
    }
  }

  // Local loading helpers
  const startLocalLoading = () => {
    localLoading.value = true
  }

  const stopLocalLoading = () => {
    localLoading.value = false
  }

  const withLocalLoading = async (asyncFunction) => {
    try {
      startLocalLoading()
      const result = await asyncFunction()
      return result
    } finally {
      stopLocalLoading()
    }
  }

  return {
    // Global loading
    globalLoading,
    showLoading,
    hideLoading,
    updateProgress,
    withLoading,
    
    // Local loading
    localLoading,
    startLocalLoading,
    stopLocalLoading,
    withLocalLoading
  }
}